import React, { useState, useEffect } from "react";
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  getActiveDevices,
  getHistoricalDevices,
  getWellActiveDevice,
  setSyncService,
} from "../../Utils/actions/yh";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  setYhAddress,
  setYhPort,
  startMonitoring as startMonitoringAction,
} from "../../Utils/utils";
import { Refresh, Settings, Edit } from "@material-ui/icons";
import TabPanel from "./TabPanel";
import DataQualityGraph from "./DataQualityGraph";
import "./DataQualityGraph.scss";
import { Card, Col, Row } from "react-bootstrap";
import "./Home.scss";
import { abbrNum, loadingOff, loadingOn } from "../../Utils/utils";
import { Link, useLocation } from "react-router-dom";
import Configuration from "./Configuraion";
import { activeDevices, activeWells, rigWellData } from "./DqDummy";
import { getApiUserRoles } from "../../Utils/actions";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { Switch } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import InfoIcon from "@mui/icons-material/Info";
import { Select, MenuItem, IconButton, Tooltip } from "@mui/material";

// import { rigCardData } from "./DqDummy";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: "8px 16px",
    fontFamily: "Roboto, sans-serif",
    display: "flex",
  },
  main: {
    width: "100%",
    height: "100vh",
    marginTop: theme.spacing(2),
    // display: "flex",
  },
}));
const Home = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [showTooltip, setShowTooltip] = useState(false);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
  const [DQGraph, setDQGraph] = useState(
    location?.state?.DQGraph === true ? true : false
  );
  const [activeRigId, setActiveRigId] = useState(
    location?.state?.rigsId ? location?.state?.rigsId : ""
  );
  const [wellId, setWellId] = useState(
    location?.state?.well ? location?.state?.well : ""
  );
  const [dataProviderWell, setDataProviderWell] = useState();
  const [dataProviderName, setDataProviderName] = useState(
    location?.state?.dataprovider ? location?.state?.dataprovider : ""
  );
  const [switchChange, setSwitchChange] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const {
    activeDevices,
    yhAddress,
    yhPort,
    monitorChannel,
    startMonitoring,
    activeWells,
    rigWellData,
    rigCardData,
    historicalDeviceLoading,
    wellProviderData,
    wellcardTotalRecords,
  } = useSelector((state) => state.yh);
  useEffect(() => {
    document.body.classList.add("rtdqv-page");
    localStorage.setItem("startMonitoring", JSON.stringify(startMonitoring));
    localStorage.setItem("yhAddress", JSON.stringify(yhAddress));
    localStorage.setItem("yhPort", JSON.stringify(yhPort));
  }, [startMonitoring, yhAddress, yhPort]);

  useEffect(() => {
    dispatch(getApiUserRoles(sessionStorage.getItem("username")));
  }, []);

  const getTableData = () => {
    const monOffChannels = Object.keys(monitorChannel).filter(
      (val) => !monitorChannel[val].monitor
    );
    // dispatch(loadingOn());
    // dispatch(getWellActiveDevice());
  };

  useEffect(() => {
    dispatch(loadingOn());
    if (
      location?.state?.checkActiveAPI !== undefined &&
      location?.state?.checkActiveAPI !== null
    ) {
      setSwitchChange(
        sessionStorage.getItem("activeTab") != undefined
          ? sessionStorage.getItem("activeTab") == "1"
            ? false
            : true
          : true
      );
      dispatch(
        getWellActiveDevice(
          sessionStorage.getItem("activeTab") != undefined
            ? sessionStorage.getItem("activeTab") == "1"
              ? false
              : true
            : switchChange,
          pageSize,
          pageIndex
        )
      );
    } else {
      dispatch(getWellActiveDevice(switchChange, pageSize, pageIndex));
    }
  }, [switchChange]);

  useEffect(() => {
    if (startMonitoring) {
      getTableData();
    }
    //eslint-disable-next-line
  }, [startMonitoring]);

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: "5px",
    backgroundColor: "rgb(251 251 251)",
    marginLeft: 0,
    width: "210px",
    border: "1px solid #d7d3d3",
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    width: "100%",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      [theme.breakpoints.up("sm")]: {
        width: "12ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
  }));

  const handleCardClick = (
    rigName,
    wellName,
    dataProviderArr,
    dataProvider
  ) => {
    setActiveRigId(rigName);
    setWellId(wellName);
    setDataProviderWell(dataProviderArr);
    setDataProviderName(dataProvider);
    setDQGraph(true);
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [filterSearch, setFilterSearch] = useState([]);

  useEffect(() => {
    // Filter data whenever rigCardData or searchQuery changes
    filterData();
  }, [rigCardData, searchQuery]);

  const handleSearchChange = (event) => {
    event.preventDefault();
    setSearchQuery(event.target.value);
  };

  const filterData = () => {
    const filtered = rigCardData.filter((item) => {
      // Filter by rig name or any other property if it exists
      const rigName = item.rigName ? item.rigName.toLowerCase() : "";
      const status = item.status ? item.status.toLowerCase() : "";
      const wellName = item.wellName ? item.wellName.toLowerCase() : "";
      const spudDate = item.spudDate ? item.spudDate.toLowerCase() : "";
      const apiNo = item.apiNo ? item.apiNo.toLowerCase() : "";
      const lastUpdatedDate = item.lastUpdatedDate
        ? item.lastUpdatedDate.toLowerCase()
        : "";
      const uwi = item.uwi ? item.uwi.toLowerCase() : "";
      const rigStatus = item.rigStatus ? item.rigStatus.toLowerCase() : "";
      const holeDepth = item.holeDepth ? item.holeDepth.toLowerCase() : "";
      const bitDepth = item.bitDepth ? item.bitDepth.toLowerCase() : "";
      const dqIndex = item.dqIndex ? item.dqIndex.toLowerCase() : "";
      const dqDashboard = item.dqDashboard
        ? item.dqDashboard.toLowerCase()
        : "";

      return (
        rigName.includes(searchQuery.toLowerCase()) ||
        status.includes(searchQuery.toLowerCase()) ||
        wellName.includes(searchQuery.toLowerCase()) ||
        spudDate.includes(searchQuery.toLowerCase()) ||
        apiNo.includes(searchQuery.toLowerCase()) ||
        lastUpdatedDate.includes(searchQuery.toLowerCase()) ||
        uwi.includes(searchQuery.toLowerCase()) ||
        rigStatus.includes(searchQuery.toLowerCase()) ||
        holeDepth.includes(searchQuery.toLowerCase()) ||
        bitDepth.includes(searchQuery.toLowerCase()) ||
        dqIndex.includes(searchQuery.toLowerCase()) ||
        dqDashboard.includes(searchQuery.toLowerCase())
      );
    });
    setFilterSearch(filtered);
  };

  const handleSwitchChange = (event) => {
    setSwitchChange(event.target.checked);
  };
  const [openConfirmSync, setOpenConfirmSync] = React.useState(false);
  const [syncData, setSyncData] = React.useState("");

  const openConfirmationModal = (item) => {
    setSyncData(item);
    setOpenConfirmSync(true);
  };

  const handleClose = () => {
    setOpenConfirmSync(false);
  };
  const handleSave = () => {
    dispatch(setSyncService(syncData.rigName, syncData.wellName));
    setOpenConfirmSync(false);
  };

  // Ensure the rest of your component is as it was, using filteredData instead of filterSearch

  // useEffect(() => {
  //   if(DQGraph) {
  //     rigCardData.map((data, index) => {
  //       if(data.rigName === location?.state?.rigsId && data.wellName === location?.state?.well) {
  //         setDataProviderWell(data.dataProvider);
  //       }
  //     }, )
  //   }
  // }, [DQGraph])

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(wellcardTotalRecords / pageSize);
    setPageIndex(totalPages - 1);
  };

  return (
    <>
      <Paper
        className={`${classes.main}`}
        id={DQGraph === true ? "chartContainer1" : ""}
      >
        {DQGraph === true ? (
          <DataQualityGraph
            selectedRig={activeRigId}
            setDQGraph={setDQGraph}
            activeWell={wellId}
            yhAddress={yhAddress}
            yhPort={yhPort}
            dataProviderName={dataProviderName}
            wellDataProvider={dataProviderWell}
            rigWellData={rigWellData}
            wellProviderData={wellProviderData}
            logJobs={location?.state?.logs}
            selectedJobDate={location?.state?.jobDate}
          />
        ) : (
          <>
            <div className="bgCard cardLayout">
              <div className="d-flex justify-content-end">
                <Stack
                  direction="row"
                  alignItems="center"
                  className="mr-4"
                  style={{ color: "#c7c7c7" }}
                >
                  <Typography
                    onClick={() => {
                      setSwitchChange(false);
                    }}
                    sx={{
                      color: switchChange ? "#888" : "#fff",
                      cursor: "pointer",
                      fontWeight: switchChange ? "normal" : "bold",
                    }}
                  >
                    Historical
                  </Typography>
                  <Switch
                    style={{ color: "#c7c7c7" }}
                    checked={switchChange}
                    onChange={(e) => {
                      handleSwitchChange(e);
                    }}
                  />
                  <Typography
                    onClick={() => {
                      setSwitchChange(true);
                    }}
                    sx={{
                      color: switchChange ? "#fff" : "#888",
                      cursor: "pointer",
                      fontWeight: switchChange ? "bold" : "normal",
                    }}
                  >
                    Live
                  </Typography>
                </Stack>
                <Search
                  style={{
                    marginBottom: "10px",
                    backgroundColor: "#242424",
                    border: "none",
                  }}
                >
                  <SearchIconWrapper>
                    <SearchIcon style={{ color: "#c7c7c7" }} />
                  </SearchIconWrapper>
                  <StyledInputBase
                    placeholder="Search…"
                    inputProps={{ "aria-label": "search" }}
                    value={searchQuery}
                    onChange={handleSearchChange}
                    autoFocus
                  />
                </Search>
              </div>
              <div
                style={{
                  height: "75vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <Row>
                  <div
                    className="d-flex bgcard-row"
                    style={{
                      flexWrap: "wrap",
                      width: "100%",
                      paddingRight: "15px",
                    }}
                  >
                    {filterSearch.length > 0 ? (
                      filterSearch?.map((item, index) => (
                        <div
                          className="col-md-3 bgcard-col"
                          style={{
                            marginBottom: "15px",
                            paddingRight: "0px",
                            cursor: "pointer",
                          }}
                          key={index}
                          onClick={() => {
                            handleCardClick(
                              item.rigName,
                              item.wellName,
                              item.dataProvider,
                              item.dataprovider
                            );
                          }}
                        >
                          <div
                            className="main-cards"
                            style={{
                              // border: "1px solid rgb(71 71 71)",
                              borderRadius: "5px",
                            }}
                          >
                            <Card key={index} className="card-contain">
                              <Card.Body style={{ padding: "10px" }}>
                                <div>
                                  <div className="d-flex">
                                    <Card.Text
                                      style={{
                                        flex: "0 0 80%",
                                        margin: "0px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        position: "relative",
                                      }}
                                      title={item.rigName ? item.rigName : "-"}
                                    >
                                      <span style={{ fontSize: "10px" }}>
                                        Rig
                                      </span>{" "}
                                      <br />
                                      <b>{item.rigName ? item.rigName : "-"}</b>
                                    </Card.Text>
                                  </div>

                                  <hr className="hrline" />

                                  <Card.Text
                                    style={{
                                      margin: "0px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      position: "relative",
                                    }}
                                    title={item.wellName ? item.wellName : "-"}
                                  >
                                    <span style={{ fontSize: "10px" }}>
                                      Well
                                    </span>

                                    <br />
                                    <b>
                                      {" "}
                                      {item.wellName ? item.wellName : "-"}
                                    </b>
                                  </Card.Text>
                                  <hr className="hrline" />

                                  <Card.Text
                                    style={{
                                      margin: "0px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      position: "relative",
                                    }}
                                    title={item.lastSync ? item.lastSync : "-"}
                                  >
                                    <span style={{ fontSize: "10px" }}>
                                      Last Updated Date
                                    </span>
                                    <br />
                                    <b>
                                      {item.lastSync === undefined ||
                                      item.lastSync === "0"
                                        ? "-"
                                        : item.lastSync}
                                    </b>
                                  </Card.Text>
                                  <hr className="hrline" />
                                  <div className="d-flex">
                                    <Card.Text
                                      style={{
                                        flex: "0 0 40%",
                                        margin: "0px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        position: "relative",
                                      }}
                                      title={item.score ? item.score : "-"}
                                    >
                                      <span style={{ fontSize: "10px" }}>
                                        Data Quality Index
                                      </span>

                                      <br />
                                      <b>{item.score ? item.score : "-"}</b>
                                    </Card.Text>
                                    <div class="vertical-line"></div>

                                    <Card.Text
                                      style={{
                                        flex: "0 0 40%",
                                        margin: "0px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        position: "relative",
                                      }}
                                      title={
                                        item.holeDepth ? item.holeDepth : "-"
                                      }
                                    >
                                      <span style={{ fontSize: "10px" }}>
                                        Hole Depth
                                      </span>

                                      <br />
                                      <b>
                                        {item.holeDepth ? item.holeDepth : "-"}
                                      </b>
                                    </Card.Text>
                                  </div>
                                  <hr className="hrline" />
                                  <div style={{ marginTop: "5px" }}>
                                    <span style={{ fontSize: "10px" }}>
                                      Data Provider
                                      <Tooltip
                                        title={
                                          <React.Fragment>
                                            {(item.dataProvider || []).map(
                                              (data, idx) => (
                                                <div key={idx}>
                                                  {data.name ? data.name : "-"}:{" "}
                                                  <b>
                                                    {data.score
                                                      ? data.score.toFixed(2) +
                                                        "%"
                                                      : "-"}
                                                  </b>
                                                </div>
                                              )
                                            )}
                                          </React.Fragment>
                                        }
                                        placement="bottom"
                                        arrow
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor: "#c7c7c7",
                                              color: "#000",
                                              fontSize: "13px",
                                              boxShadow: 1,
                                              border: "1px solid #ccc",
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: "#c7c7c7",
                                            },
                                          },
                                        }}
                                      >
                                        <IconButton>
                                          <InfoIcon />
                                        </IconButton>
                                      </Tooltip>
                                      {/* <i
                                        style={{
                                          marginLeft: "5px",
                                          cursor: "pointer",
                                          verticalAlign: "middle",
                                        }}
                                        className="fa fa-info-circle"
                                        onMouseEnter={() =>
                                          setHoveredCardIndex(index)
                                        }
                                        onMouseLeave={() =>
                                          setHoveredCardIndex(null)
                                        }
                                        onClick={() =>
                                          setHoveredCardIndex(null)
                                        }
                                      ></i> */}
                                    </span>

                                    {/* {hoveredCardIndex === index && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          zIndex: 1000,
                                          background: "#fff",
                                          boxShadow:
                                            "0px 2px 6px rgba(0,0,0,0.2)",
                                          padding: "10px",
                                          borderRadius: "4px",
                                          left: "95px",
                                          bottom: "0px",
                                          minWidth: "150px",
                                          border: "1px solid grey",
                                        }}
                                      >
                                        {(item.dataProvider || []).map(
                                          function (data, idx) {
                                            return (
                                              <div
                                                key={idx}
                                                style={{
                                                  marginBottom: "4px",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  color: "#242424",
                                                }}
                                                title={`${
                                                  data.name ? data.name : "-"
                                                }: ${
                                                  data.score
                                                    ? data.score.toFixed(2) +
                                                      "%"
                                                    : "-"
                                                }`}
                                              >
                                                {data.name ? data.name : "-"}:
                                                <b>
                                                  {" "}
                                                  {data.score
                                                    ? data.score.toFixed(2) +
                                                      "%"
                                                    : "-"}
                                                </b>
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    )} */}
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="no-records-found">
                        <b>No Records Found</b>
                      </div>
                    )}
                  </div>
                </Row>
              </div>
              <div
                style={{
                  marginLeft: "auto",
                  position: "absolute",
                  bottom: "17px",
                  right: "20px",
                }}
              >
                <span>Rows per Page </span>&nbsp;
                <FormControl variant="standard" size="small">
                  <Select
                    value={pageSize}
                    onChange={(e) =>
                      handlePageSizeChange(Number(e.target.value))
                    }
                    style={{ color: "#c7c7c7" }}
                  >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                &nbsp;
                <span>
                  {pageIndex * pageSize + 1}-
                  {Math.min(
                    pageIndex * pageSize + pageSize,
                    wellcardTotalRecords
                  )}{" "}
                  of &nbsp;
                  {wellcardTotalRecords}&nbsp;
                </span>
                <FirstPageIcon
                  onClick={() => {
                    if (pageIndex !== 0) {
                      handleStartChange();
                    }
                  }}
                  style={{
                    cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                    color:
                      pageIndex === 0 ? "rgb(255 255 255 / 26%)" : "inherit",
                  }}
                />
                <NavigateBeforeIcon
                  onClick={() => {
                    if (pageIndex !== 0) {
                      handlePageChange(pageIndex - 1);
                    }
                  }}
                  style={{
                    cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                    color:
                      pageIndex === 0 ? "rgb(255 255 255 / 26%)" : "inherit",
                  }}
                />
                <NavigateNextIcon
                  onClick={() => {
                    if ((pageIndex + 1) * pageSize < wellcardTotalRecords) {
                      handlePageChange(pageIndex + 1);
                    }
                  }}
                  style={{
                    cursor:
                      (pageIndex + 1) * pageSize >= wellcardTotalRecords
                        ? "not-allowed"
                        : "pointer",
                    color:
                      (pageIndex + 1) * pageSize >= wellcardTotalRecords
                        ? "rgb(255 255 255 / 26%)"
                        : "inherit",
                  }}
                />
                <LastPageIcon
                  onClick={() => {
                    if ((pageIndex + 1) * pageSize < wellcardTotalRecords) {
                      handleEndChange();
                    }
                  }}
                  style={{
                    cursor:
                      (pageIndex + 1) * pageSize >= wellcardTotalRecords
                        ? "not-allowed"
                        : "pointer",
                    color:
                      (pageIndex + 1) * pageSize >= wellcardTotalRecords
                        ? "rgba(0, 0, 0, 0.26)"
                        : "inherit",
                  }}
                />
              </div>
            </div>
          </>
        )}

        {/* <Dialog open={openConfirmSync} onClose={handleClose}>
          <DialogTitle>Sync Manage</DialogTitle>
          <DialogContent dividers>
            Are you sure you want to sync ?
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="contained" color="secondary">
              No
            </Button>
            <Button
              onClick={handleSave}
              variant="contained"
              style={{ backgroundColor: "#206e95", color: "white" }}
            >
              {" "}
              Yes
            </Button>
          </DialogActions>
        </Dialog> */}
      </Paper>
    </>
  );
};

export default Home;
